// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  position: relative;

  .collapsible-header {
    cursor: pointer;
    height: 50px;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    box-sizing: border-box;
    width: 100%;
    border: none;
    background: none;
    display: ${(props) => (props.isDefaultView ? 'none' : 'block')};
    ${(props) =>
      props.showHeaderAlways
        ? css`
            height: auto;
            display: block;
            padding: 0;
          `
        : css`
            @media ${props.theme.mediaQuery.medium} {
              display: none;
            }
          `};
  }

  .collapsible-icon {
    position: absolute;
    right: 0;
    display: ${(props) => (props.isAccordionTablet ? 'block' : 'none')};
    top: 30px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: ${(props) => (props.showHeaderAlways && props.isDefaultView ? 'none' : 'block')};
    }
  }

  .item-opened {
    display: block;
  }

  .item-closed {
    display: ${(props) => (props.isDefaultView ? 'block' : 'none')};
  }

  .collapsible-div {
    position: absolute;
    right: 0px;
    padding: 4px;
    display: block;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: ${(props) => (props.isAccordionTablet ? 'block' : 'none')};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 16px;
    }
  }
`;

export default styles;
